export const strings = {
  english: {
    name: 'Display name *',
    email: 'Email address *',
    password: 'Current password (leave blank to leave unchanged)',
    newPassword: 'New password (leave blank to leave unchanged)',
    confirmPassword: 'Confirm new password',
    button: 'SAVE CHANGES',
    hero: 'Password change',
  },

  japan: {
    name: '表示名 *',
    email: 'メールアドレス *',
    password: '現在のパスワード (変更しない場合は空欄)',
    newPassword: '新しいパスワード (変更しない場合は空欄)',
    confirmPassword: '新しいパスワードを確認',
    button: '変更を保存',
    hero: 'パスワードの変更',
  },
};
